module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-ad7d3d53.png";